import React, { useState, useEffect } from "react";
import { NavLink, Link, useLocation } from "../router";
import Logo from "./Logo";

const LINKS = [
  { to: "/properties", label: "Portfolio" },
  { to: "/about", label: "The House" },
  { to: "/investors", label: "Wealth Desk" },
  { to: "/careers", label: "Careers" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [pathname]);

  return (
    <header
      style={{
        position: "sticky", top: 0, zIndex: 100,
        background: scrolled ? "rgba(255,255,255,0.85)" : "transparent",
        backdropFilter: scrolled ? "saturate(200%) blur(18px)" : "none",
        borderBottom: scrolled ? "1px solid var(--hairline-soft)" : "1px solid transparent",
        transition: "all 0.65s var(--ease)",
      }}
    >
      <nav
        className="shell"
        style={{ display: "flex", alignItems: "center", justifyContent: "space-between", height: 92 }}
      >
        <Link to="/" aria-label="Aditi Realty home"><Logo /></Link>

        <div className="nav-desktop" style={{ display: "flex", alignItems: "center", gap: 44 }}>
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              style={({ isActive }) => ({
                fontSize: "0.79rem",
                fontWeight: 500,
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                color: isActive ? "var(--ink)" : "var(--ink-soft)",
                borderBottom: isActive ? "1px solid var(--champagne)" : "1px solid transparent",
                paddingBottom: 6,
                transition: "all 0.5s var(--ease)",
              })}
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/sell" className="btn btn-ink" style={{ padding: "13px 24px" }}>
            List an Asset
          </Link>
        </div>

        <button
          className="nav-toggle"
          aria-label="Menu"
          onClick={() => setOpen((o) => !o)}
          style={{ display: "none", background: "none", border: "none", padding: 10 }}
        >
          <span style={{ fontSize: "1.4rem" }}>{open ? "✕" : "☰"}</span>
        </button>
      </nav>

      {open && (
        <div className="shell" style={{ paddingBottom: 28, display: "flex", flexDirection: "column", gap: 20 }}>
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} style={{ fontSize: "0.95rem", color: "var(--ink)", fontWeight: 500 }}>
              {l.label}
            </NavLink>
          ))}
          <Link to="/sell" className="btn btn-ink" style={{ alignSelf: "flex-start", marginTop: 8 }}>List an Asset</Link>
        </div>
      )}

      <style>{`
        @media (max-width: 900px) {
          .nav-desktop { display: none !important; }
          .nav-toggle { display: block !important; }
          header { background: rgba(255,255,255,0.92) !important; backdrop-filter: saturate(200%) blur(18px); border-bottom: 1px solid var(--hairline-soft); }
        }
      `}</style>
    </header>
  );
}
